import { render, staticRenderFns } from "./OrgUsersTeams.vue?vue&type=template&id=48ad390e&scoped=true&"
import script from "./OrgUsersTeams.vue?vue&type=script&lang=js&"
export * from "./OrgUsersTeams.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48ad390e",
  null
  
)

export default component.exports